import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const DescribeYourProjectView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Current Project
    const bizObjectiveError = props.validationErrors.bizObjective.show;
    const bizObjectiveHelperText = props.validationErrors.bizObjective.show ? props.validationErrors.bizObjective.errorMessage : '';
  
    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020">    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="currentProject">
                                PROJECT DESCRIPTION
                            </h3>
                        </CardHeader>    
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="bizObjective">
                                Describe Your Trading Online Project&nbsp;
                                {props.validationErrors.bizObjective.check === null ? ' ' : (props.validationErrors.bizObjective.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>You need to provide specific examples of what business activities or processes are expected to be helped or improved with this project.</p>
                                                    <p>It could be things like <b>handling sales</b>, <b>generating new leads</b>, <b>customer service</b> etc.</p>
                                                    <p>An example of <b>handling sales</b> could be integrating Irish company <a href="https://stripe.com" target="_blank" rel="noopener">Stripe</a> as a payment processor to enable credit card payments on your website.</p>
                                                    <p>An example of <b>generating new leads</b> could be a digital marketing campaign using <a href="https://ads.google.com" target="_blank" rel="noopener">Google Ads</a> or various social media platforms.</p>
                                                    <p>An example of <b>customer service</b> could be using <a href="https://developers.facebook.com/products/messenger/customer-care/" target="_blank" rel="noopener">Facebook Messenger</a> to answer common customer queries 24/7 instantly.</p>
                            
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='bizObjectiveInput'
                                        labelText=''
                                        helperText={bizObjectiveHelperText}
                                        error={bizObjectiveError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'bizObjective',
                                            value: props.bizObjective,
                                            onChange: props.handleBizObjective,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'flag-checkered']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_DESCRIBE}>
                                    &lt; Describe Your Business 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_PLAN}>
                                    Project Plan &gt;
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

DescribeYourProjectView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // Current Project
    handleBizObjective: PropTypes.func.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(DescribeYourProjectView));